fragment productOptionSwatchesFragment on Product {
  _optionSwatches: metafield(namespace: "oneworld", key: "optionSwatches") {
    value
    type
  }
}
